import { NONCE_PLACEHOLDER } from './nonce.ts'

/** Storage key. Kept from the design prototype so an early reader's choice survives. */
export const THEME_STORAGE_KEY = 'mc-tema'

/** Attribute stamped on `<html>`. Absent means "follow the system". */
export const THEME_ATTRIBUTE = 'data-tema'

/**
 * The one place in this repository where hand-written inline JavaScript is
 * sanctioned, and the constraints on it are correspondingly tight.
 *
 * WHY IT EXISTS: the only correct moment to resolve a persisted theme is before
 * first paint. Reading storage after hydration means the reader sees the wrong
 * theme for a frame and then watches it change — which is worse than not
 * persisting at all.
 *
 * WHY IT IS ALLOWED: `script-src 'self'` admits an inline script only with a
 * nonce. That pipeline already exists and is currently used for JSON-LD, so this
 * is its second consumer and `script-src` gains nothing new.
 *
 * CONSTRAINTS, all load-bearing:
 *
 *  - ES5 syntax and under 200 bytes. It runs before any module and must not
 *    depend on module semantics.
 *  - The `try`/`catch` is required, not defensive habit. `localStorage` throws
 *    outright in Safari private mode and under some cookie-blocking
 *    configurations; an uncaught throw here aborts head parsing. The Lighthouse
 *    gate is `errors-in-console: maxLength 0`.
 *  - It only ever ADDS the attribute. Absence is the "follow the system" state,
 *    which the cascade in `_tokens.sass` already handles.
 *  - No `eval`, no `new Function`, no `document.write`.
 */
export const THEME_BOOTSTRAP_SCRIPT = `<script nonce="${NONCE_PLACEHOLDER}">try{var t=localStorage.getItem('${THEME_STORAGE_KEY}');if(t==='claro'||t==='escuro')document.documentElement.setAttribute('${THEME_ATTRIBUTE}',t)}catch(e){}</script>`
